import React, { useEffect, useRef, useState } from "react";

const LINKS = [
  { href: "#landing", label: "Home" },
  { href: "#projects", label: "Projects" },
  { href: "#education", label: "Education" },
  { href: "#contact", label: "Contact" },
];

// Centered links while the landing hero is in view; a burger + right-hand
// drawer once you scroll past it (and always on mobile — CSS decides that,
// the JS only tracks the landing section).
export default function NavBar() {
  const [atTop, setAtTop] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const burgerRef = useRef(null);
  const firstLinkRef = useRef(null);

  useEffect(() => {
    const landing = document.getElementById("landing");
    if (!landing) return;
    // IO instead of scroll listeners: unaffected by snap easing and fires
    // correctly after useScrollRestoration's instant jump
    const observer = new IntersectionObserver(
      ([entry]) => setAtTop(entry.intersectionRatio >= 0.5),
      { threshold: 0.5 }
    );
    observer.observe(landing);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!menuOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    document.addEventListener("keydown", onKey);
    firstLinkRef.current?.focus();
    return () => document.removeEventListener("keydown", onKey);
  }, [menuOpen]);

  const close = () => {
    setMenuOpen(false);
    burgerRef.current?.focus();
  };

  return (
    <nav
      className={`nav ${atTop ? "nav--center" : "nav--burger"}${
        menuOpen ? " nav--open" : ""
      }`}
    >
      <ul className="nav-links">
        {LINKS.map((l) => (
          <li key={l.href}>
            <a href={l.href}>{l.label}</a>
          </li>
        ))}
      </ul>

      <button
        ref={burgerRef}
        className="nav-burger-btn"
        aria-label={menuOpen ? "Close menu" : "Open menu"}
        aria-expanded={menuOpen}
        aria-controls="nav-drawer"
        onClick={() => setMenuOpen((o) => !o)}
      >
        <span />
        <span />
        <span />
      </button>

      <div className="nav-overlay" onClick={close} aria-hidden="true" />

      <div id="nav-drawer" className="nav-drawer" aria-hidden={!menuOpen}>
        <ul>
          {LINKS.map((l, i) => (
            <li key={l.href}>
              <a
                href={l.href}
                ref={i === 0 ? firstLinkRef : undefined}
                tabIndex={menuOpen ? 0 : -1}
                onClick={() => setMenuOpen(false)}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
